import React, { useState, useCallback, useEffect } from "react";

import swal from "sweetalert";
import {
  Form,
  Input,
  FormField,
  FormGroup,
  Button,
  Select,
} from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api } from "../../../../services/apis";

import {
  Container,
  Box,
  Header,
  FormBlock,
  TableContainer,
  Destino,
} from "./styles";
import { isAuthAdmin } from "../../../../services/auth";

import Table from "../../../../components/Table/templates/inscricoes";
import Controls from "../../../../components/Controls";

const RelatorioInscricoesMinificado = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [curso, setCurso] = useState("");
  const [options, setOptions] = useState([]);

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);
  const [inscricoes, setInscricoes] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const handleGenerateReport = useCallback(() => {
    setLoading(true);
    setRelatorio(false);

    api
      .post("/admin/reports/inscricao-pagas", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      })
      .then((res) => {
        setRelatorio(res.data.url);
        setLoading(false);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
        swal("Confirmado!", "Relatório gerado com sucesso", "success");

        window.open(res.data.url, "blank");
      })
      .catch((error) => {
        setLoading(false);
        if (!error.response) {
          return;
        }

        swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
      });
  }, [dataInicio, dataFinal, swal]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório Inscrições</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              {relatorio && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorio, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>

        {/* <TableContainer>
          <Controls count={total} page={page} handleChange={handleChange} />

          <Table inscricoes={inscricoes} />

          <Controls count={total} page={page} handleChange={handleChange} />
        </TableContainer> */}
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioInscricoesMinificado;
